// dateUtils.js

/**
 * Преобразует дату в строку YYYY-MM-DD в часовом поясе Майами (America/New_York)
 */
export function toMiamiDateString(date) {
  const d = new Date(date);
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/New_York',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).format(d).replace(/(\d+)\/(\d+)\/(\d+)/, '$3-$1-$2'); // en-CA возвращает YYYY-MM-DD, но для надежности
}

/**
 * Форматирует дату для отображения (например, "Mar 3") в поясе Майами
 */
export function formatMiamiShort(date) {
  const d = new Date(date);
  return new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    month: 'short',
    day: 'numeric'
  }).format(d);
}

/**
 * Создает объект Date в поясе Майами из строки YYYY-MM-DD
 */
export function miamiDateFromString(dateStr) {
  const [year, month, day] = dateStr.split('-').map(Number);
  // Создаем дату в UTC, затем преобразуем в локальное время Майами через Intl
  const utcDate = new Date(Date.UTC(year, month - 1, day, 12, 0, 0)); // Полдень UTC чтобы избежать граничных эффектов
  return new Date(utcDate.toLocaleString('en-US', { timeZone: 'America/New_York' }));
}

/**
 * Возвращает диапазон текущей недели (Пн–Вс) в поясе Майами
 */
export function getCurrentMiamiWeekRange() {
  const year = new Date().getFullYear();
  const weeks = getMiamiWeeksOfYear(year);
  const todayStr = toMiamiDateString(new Date());
  const current = weeks.find(w =>
    toMiamiDateString(w.start) <= todayStr && toMiamiDateString(w.end) >= todayStr
  );
  const week = current || weeks[weeks.length - 1];
  return { start: toMiamiDateString(week.start), end: toMiamiDateString(week.end) };
}

/**
 * Генерирует недели года в поясе Майами
 */
export function getMiamiWeeksOfYear(year) {
  const weeks = [];
  
  // Находим понедельник недели, содержащей 1 января, в поясе Майами
  const jan1 = new Date(Date.UTC(year, 0, 1, 12, 0, 0));
  const jan1Miami = new Date(jan1.toLocaleString('en-US', { timeZone: 'America/New_York' }));
  
  // Определяем день недели в Майами (0 = воскресенье, 1 = понедельник, ...)
  const dow = jan1Miami.getDay();
  const daysToMonday = dow === 0 ? 6 : dow - 1;
  
  // Создаем дату понедельника в UTC полдень
  const monday = new Date(Date.UTC(year, 0, 1 - daysToMonday, 12, 0, 0));
  
  while (true) {
    const start = new Date(monday);
    const startMiami = new Date(start.toLocaleString('en-US', { timeZone: 'America/New_York' }));
    
    if (startMiami.getFullYear() > year) break;
    
    const days = [];
    for (let i = 0; i < 7; i++) {
      const day = new Date(monday);
      day.setUTCDate(monday.getUTCDate() + i);
      days.push(new Date(day));
    }
    
    const end = new Date(days[6]);
    
    weeks.push({
      weekNum: weeks.length + 1,
      start: new Date(start),
      end: new Date(end),
      days: days.map(d => new Date(d))
    });
    
    monday.setUTCDate(monday.getUTCDate() + 7);
  }
  
  return weeks;
}